import { defineStore } from "pinia";
import { useCurationExperienceStore } from "@/features/experience-curation/stores/useCurationExperienceStore";
import { areNonCommercialFieldsEditableForUser } from "@/features/experience-curation/lib/viewTypeUtils";
import { useCurrentExperienceAdditionalCitiesQuery } from "@/features/experience-shared/queries/useExperienceAdditionalCitiesQuery";
import { useHasFunctionalFieldChange } from "@/features/experience-curation/queries/useHasRawFieldChange";
import { useAdditionalCitiesField } from "@/features/experience-shared/composables/location/useAdditionalCitiesField";

export const useCurationAdditionalCities = defineStore("curation-location-additional-cities-field", () => {
  const curationExperienceStore = useCurationExperienceStore();
  const additionalCitiesQuery = useCurrentExperienceAdditionalCitiesQuery();

  const cityCodes = computed(() => additionalCitiesQuery.data.value?.additional_cities ?? []);
  const field = useAdditionalCitiesField(cityCodes);

  const isReadonly = computed(() => curationExperienceStore.isReadonly || !areNonCommercialFieldsEditableForUser());
  const isVisible = computed(() => !curationExperienceStore.isCommercialView);
  const hasUnpublishedChange = useHasFunctionalFieldChange("additional_cities");

  return { ...field, isReadonly, isVisible, hasUnpublishedChange };
});
